import { render, staticRenderFns } from "./GroupQuestionsPage.vue?vue&type=template&id=d48911d4&"
import script from "./GroupQuestionsPage.vue?vue&type=script&lang=ts&"
export * from "./GroupQuestionsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
